/**
 * Bolivian Mvdol.
 */
export var BOV = {
  code: 'BOV',
  base: 10,
  exponent: 2
};